import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '../../button/button';
import styles from './modal_button.css';

/**
 * @todo remove this component as it's completely redundant, it passes ever props to Button component without manipulate anything...
 * Render a Button component with the appropriate properties.
 * This component is used to render Buttons that either open or close the modal.
 * @param {Object} args The destructured arguments
 * @param {Object} args.visualProps The visualProps
 * @param {Object} args.contentProps The contentProps
 * @param {Object} args.eventProps The eventProps
 * @param {Object} args.elementProps The elementProps
 * @param {Array} args.rules The rules for visibility
 * @param {Function} args.onClickFunction This is either openModal or closeModal, passed from ModalContainer
 * @returns {Node} A Button component
 * @constructor
 */
const ModalButton = ({ visualProps = {}, contentProps = {}, eventProps = {}, elementProps = {}, stateProps = {}, rules = [], onClickFunction }) => {
    return (
        <Button
            className={styles[`variant_${visualProps.variant}`]}
            {...contentProps}
            {...elementProps}
            {...visualProps}
            { ...eventProps }
            onClickFunction={onClickFunction}
            stateProps={stateProps}
            rules={rules}
        />
    );
};

ModalButton.propTypes = {
    contentProps: PropTypes.object,
    elementProps: PropTypes.object,
    eventProps: PropTypes.object,
    onClickFunction: PropTypes.func,
    rules: PropTypes.array,
    visualProps: PropTypes.object,
    stateProps: PropTypes.object
};

export { ModalButton };
